// extracted by mini-css-extract-plugin
module.exports = {"gallerySection":"style_gallerySection__2VM7-"};